export const ALERTS_URL = '/v2/alerts';
